import { IOpChangeState, IJsonSerializable } from "../util/interfaces";
import { OpDescr } from "../core/op-descr";
import { Enums } from "../common/enums";

export class OpProblemClass implements IOpChangeState, IJsonSerializable {

    //#region Properties

    public idProblemClass: number
    public idDescr: number
    public name: string

    //#endregion


    //#region NavigationProperties

    private _descr: OpDescr
    public get descr(): OpDescr {
        return this._descr
    }
    public set descr(value: OpDescr) {
        this._descr = value
        this.idDescr = value != null ? value.idDescr : null
    }

    //#endregion


    // #region Ctor

    public constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion


    //#region IOpChangeState Implementation

    public opState: Enums.OpChangeState;

    //#endregion


    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null

            this.idProblemClass = opObj.ID_PROBLEM_CLASS
            this.idDescr = opObj.ID_DESCR
            this.name = opObj.NAME
        }
    }

    public toJSON(): any {
        return {
            ID_PROBLEM_CLASS: this.idProblemClass,
            NAME: this.name,
            ID_DESCR: this.idDescr
        }
    }

    //#endregion


    // #region	toString

    public toString(): string {
        if (this.descr != null) {
            return this.descr.description;
        }

        return this.name;
    }

    //#endregion

}